import { Button, Flex, Table, TableRowMenuCell } from '@/components';
import { useProjectPermission } from '@/features/authentication/_hooks/permission';
import { sortByName } from '@/features/mold/utils';
import { useProject } from '@/features/project/_hooks/project';
import { useId } from '@/hooks';
import { TABLE_ROW_MENU_WIDTH } from '@/utils';
import Column from 'antd/es/table/Column';
import ColumnGroup from 'antd/es/table/ColumnGroup';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { IndonesiaData } from '../../../_models/indonesia-data';
import { useProjectDetailDrawerState } from '../../_components/ProjectDrawerStateProvider';

type Props = {
  data: IndonesiaData['biayaTenaga'];
  fiscalYear: number;

  onClickDelete: (value: { id: string; type: 'Biaya' | 'Belanja' }) => void;
};

export const BiayaProgramTable: FC<Props> = ({
  data,
  fiscalYear,
  onClickDelete,
}) => {
  const { t } = useTranslation();
  const { id } = useId();
  const { setDrawerState } = useProjectDetailDrawerState();
  const project = useProject(id);
  const editPermission = useProjectPermission(true);

  const enableEdit =
    project.data && !project.data.isLocked && editPermission.data;

  return (
    <Table
      bordered={true}
      enableSticky={false}
      rowKey="id"
      dataSource={sortByName(data)}
      locale={{ emptyText: 'Tidak ada data.' }}
      pagination={false}
    >
      <Column title={t('biaya')} dataIndex="name" key="name" />
      <ColumnGroup title={fiscalYear}>
        <Column title={t('org')} dataIndex="currentYearOrg" />
        <Column title={t('rp')} dataIndex="currentYearRp" />
      </ColumnGroup>
      <ColumnGroup title={fiscalYear - 1}>
        <Column title={t('org')} dataIndex="previousYearOrg" />
        <Column title={t('rp')} dataIndex="previousYearRp" />
      </ColumnGroup>
      {enableEdit && (
        <Column
          title={
            <Flex justify="center">
              <Button
                onClick={() => {
                  setDrawerState({
                    open: true,
                    type: 'expenditure-item',
                    isEditing: false,
                    mode: 'Biaya',
                  });
                }}
              >
                {t('create')}
              </Button>
            </Flex>
          }
          width={TABLE_ROW_MENU_WIDTH}
          dataIndex="actions"
          render={(_, record) => {
            return (
              <Flex justify="center">
                <TableRowMenuCell
                  onEdit={() => {
                    setDrawerState({
                      open: true,
                      type: 'expenditure-item',
                      isEditing: true,
                      id: record.id,
                      mode: 'Biaya',
                    });
                  }}
                  items={[
                    {
                      key: 'delete',
                      label: t('delete'),
                      danger: true,
                      onClick: () => {
                        onClickDelete({
                          id: record.id,
                          type: 'Biaya',
                        });
                      },
                    },
                  ]}
                />
              </Flex>
            );
          }}
        />
      )}
    </Table>
  );
};
